/* =========================================================
   CENUNO — comportamiento propio (vanilla, sin librerias)
   Cada init comprueba si su elemento existe, asi el mismo
   archivo sirve para todas las paginas.
   ========================================================= */
(function () {
  "use strict";

  var sinMovimiento =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* --- Animaciones de entrada (un solo observador compartido) ----------- */
  function initReveals(raiz) {
    var elementos = (raiz || document).querySelectorAll(".mt-reveal:not(.mt-observado)");
    if (!elementos.length) return;

    if (sinMovimiento || !("IntersectionObserver" in window)) {
      elementos.forEach(function (el) {
        el.classList.add("mt-observado", "mt-visible");
      });
      return;
    }

    if (!window.__mtObs) {
      window.__mtObs = new IntersectionObserver(
        function (entradas, obs) {
          entradas.forEach(function (e) {
            if (!e.isIntersecting) return;
            e.target.classList.add("mt-visible");
            obs.unobserve(e.target);
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
      );
    }

    elementos.forEach(function (el) {
      el.classList.add("mt-observado");
      window.__mtObs.observe(el);
    });
  }

  /* --- Cifras que cuentan al entrar en pantalla ------------------------- */
  function initCifras(raiz) {
    var cifras = (raiz || document).querySelectorAll("[data-mt-contador]:not(.mt-contado)");
    if (!cifras.length) return;

    function animar(el) {
      var destino = parseFloat(el.getAttribute("data-mt-contador"));
      if (isNaN(destino)) return;
      var decimales = (el.getAttribute("data-mt-decimales") || "0") | 0;
      var sufijo = el.getAttribute("data-mt-sufijo") || "";
      var prefijo = el.getAttribute("data-mt-prefijo") || "";
      if (sinMovimiento) {
        el.textContent = prefijo + destino.toFixed(decimales) + sufijo;
        return;
      }
      var inicio = null;
      var dur = 1600;
      function paso(t) {
        if (inicio === null) inicio = t;
        var p = Math.min((t - inicio) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefijo + (destino * eased).toFixed(decimales) + sufijo;
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    if (!("IntersectionObserver" in window)) {
      cifras.forEach(function (el) {
        el.classList.add("mt-contado");
        animar(el);
      });
      return;
    }

    var obs = new IntersectionObserver(
      function (entradas, o) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          animar(e.target);
          o.unobserve(e.target);
        });
      },
      { threshold: 0.6 }
    );
    cifras.forEach(function (el) {
      el.classList.add("mt-contado");
      obs.observe(el);
    });
  }

  /* --- Parallax suave del hero (solo transform, via rAF) ---------------- */
  function initParallax(raiz) {
    var capas = (raiz || document).querySelectorAll("[data-mt-parallax]:not(.mt-parallax-on)");
    if (!capas.length || sinMovimiento) return;
    if (window.matchMedia("(max-width: 990px)").matches) return;

    capas.forEach(function (el) {
      el.classList.add("mt-parallax-on");
    });

    if (window.__mtParallax) return;
    window.__mtParallax = true;

    var pendiente = false;
    function pintar() {
      pendiente = false;
      document.querySelectorAll(".mt-parallax-on").forEach(function (el) {
        var caja = el.parentElement.getBoundingClientRect();
        if (caja.bottom < -200 || caja.top > window.innerHeight + 200) return;
        var intensidad = parseFloat(el.getAttribute("data-mt-parallax")) || 12;
        var centro = caja.top + caja.height / 2 - window.innerHeight / 2;
        var avance = centro / window.innerHeight;
        el.style.transform = "translate3d(0," + (avance * intensidad).toFixed(2) + "%,0)";
      });
    }
    function alScroll() {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(pintar);
    }
    window.addEventListener("scroll", alScroll, { passive: true });
    window.addEventListener("resize", alScroll, { passive: true });
    pintar();
  }

  /* --- Selector de color de la portada ---------------------------------- */
  function initColores(raiz) {
    var bloques = (raiz || document).querySelectorAll("[data-mt-colores]:not(.mt-colores-on)");
    bloques.forEach(function (bloque) {
      bloque.classList.add("mt-colores-on");
      var botones = bloque.querySelectorAll(".mt-swatch");
      var fotos = bloque.querySelectorAll(".mt-colores__foto");
      var nombre = bloque.querySelector("[data-mt-color-nombre]");
      var enlace = bloque.querySelector("[data-mt-color-enlace]");

      botones.forEach(function (btn, i) {
        btn.addEventListener("click", function () {
          botones.forEach(function (b) {
            b.classList.remove("mt-activa");
            b.setAttribute("aria-pressed", "false");
          });
          fotos.forEach(function (f) {
            f.classList.remove("mt-activa");
          });
          btn.classList.add("mt-activa");
          btn.setAttribute("aria-pressed", "true");
          if (fotos[i]) fotos[i].classList.add("mt-activa");
          if (nombre) nombre.textContent = btn.getAttribute("data-mt-nombre") || "";
          var url = btn.getAttribute("data-mt-url");
          if (enlace && url) enlace.setAttribute("href", url);
        });
      });
    });
  }

  /* --- Preguntas frecuentes (acordeon) ---------------------------------- */
  function initFaq(raiz) {
    var items = (raiz || document).querySelectorAll(".mt-faq__item:not(.mt-faq-on)");
    items.forEach(function (item) {
      item.classList.add("mt-faq-on");
      var btn = item.querySelector(".mt-faq__btn");
      var panel = item.querySelector(".mt-faq__panel");
      if (!btn || !panel) return;
      btn.addEventListener("click", function () {
        var abierto = item.classList.contains("mt-abierto");
        var lista = item.closest(".mt-faq__lista");
        if (lista && !lista.hasAttribute("data-mt-multiple")) {
          lista.querySelectorAll(".mt-faq__item.mt-abierto").forEach(function (o) {
            if (o === item) return;
            o.classList.remove("mt-abierto");
            var b = o.querySelector(".mt-faq__btn");
            if (b) b.setAttribute("aria-expanded", "false");
          });
        }
        item.classList.toggle("mt-abierto", !abierto);
        btn.setAttribute("aria-expanded", String(!abierto));
      });
    });
  }

  /* --- Galeria + variantes de la pagina de producto --------------------- */
  function initProducto(raiz) {
    var bloques = (raiz || document).querySelectorAll("[data-mt-producto]:not(.mt-prod-on)");
    bloques.forEach(function (bloque) {
      bloque.classList.add("mt-prod-on");

      /* Galeria */
      var minis = bloque.querySelectorAll(".mt-prod__mini");
      var slides = bloque.querySelectorAll(".mt-prod__slide");
      function mostrar(i) {
        minis.forEach(function (m) {
          m.classList.remove("mt-activa");
        });
        slides.forEach(function (s) {
          s.classList.remove("mt-activa");
        });
        if (minis[i]) minis[i].classList.add("mt-activa");
        if (slides[i]) slides[i].classList.add("mt-activa");
      }
      minis.forEach(function (m, i) {
        m.addEventListener("click", function () {
          mostrar(i);
        });
      });

      /* Variantes */
      var botones = bloque.querySelectorAll(".mt-prod__variante");
      var input = bloque.querySelector("[data-mt-variant-id]");
      var etiqueta = bloque.querySelector("[data-mt-opcion-valor]");
      var precio = bloque.querySelector("[data-mt-precio]");
      var antes = bloque.querySelector(".mt-prod__precio-antes");
      var boton = bloque.querySelector("[data-mt-submit]");

      botones.forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (btn.hasAttribute("disabled")) return;
          botones.forEach(function (b) {
            b.classList.remove("mt-activa");
            b.setAttribute("aria-pressed", "false");
          });
          btn.classList.add("mt-activa");
          btn.setAttribute("aria-pressed", "true");

          if (input) input.value = btn.getAttribute("data-mt-id") || input.value;
          if (etiqueta) etiqueta.textContent = btn.getAttribute("data-mt-nombre") || "";
          if (precio && btn.getAttribute("data-mt-precio-txt")) {
            precio.textContent = btn.getAttribute("data-mt-precio-txt");
          }
          if (antes) {
            var txtAntes = btn.getAttribute("data-mt-antes-txt") || "";
            antes.textContent = txtAntes;
            antes.style.display = txtAntes ? "" : "none";
          }
          if (boton) {
            var disp = btn.getAttribute("data-mt-disponible") === "true";
            boton.disabled = !disp;
            var txt = boton.querySelector("[data-mt-submit-txt]");
            if (txt) {
              txt.textContent = disp
                ? boton.getAttribute("data-mt-txt-ok") || "Añadir al carrito"
                : boton.getAttribute("data-mt-txt-ko") || "Agotado";
            }
          }
          /* Salta a la foto de ese color si la tiene */
          var idxFoto = btn.getAttribute("data-mt-foto");
          if (idxFoto !== null && idxFoto !== "") mostrar(parseInt(idxFoto, 10));
        });
      });

      /* Cantidad */
      var stepper = bloque.querySelector(".mt-prod__stepper");
      if (stepper) {
        var campo = stepper.querySelector("input");
        stepper.querySelectorAll("button").forEach(function (b) {
          b.addEventListener("click", function () {
            var paso = b.getAttribute("data-mt-paso") === "-" ? -1 : 1;
            var v = parseInt(campo.value, 10) || 1;
            campo.value = Math.max(1, v + paso);
          });
        });
      }
    });
  }

  /* --- Arranque + soporte del editor de Shopify ------------------------- */
  function initTodo(raiz) {
    initReveals(raiz);
    initCifras(raiz);
    initParallax(raiz);
    initColores(raiz);
    initFaq(raiz);
    initProducto(raiz);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initTodo(document);
    });
  } else {
    initTodo(document);
  }

  document.addEventListener("shopify:section:load", function (e) {
    initTodo(e.target);
  });
  document.addEventListener("shopify:section:select", function (e) {
    initTodo(e.target);
  });
})();
